import { type Component } from "dreamland/core";
import { router } from "dreamland/router";
import { auth, normalizeInstanceDomain, ApiError } from "../api";
import { AUTH_CONFIG } from "../config";

const Login: Component<
	{},
	{
		instanceDomain: string;
		error: string | null;
		loading: boolean;
	}
> = function () {
	this.instanceDomain = "";
	this.error = null;
	this.loading = false;

	const handleSubmit = async (e: Event) => {
		e.preventDefault();

		if (!this.instanceDomain.trim()) {
			this.error = "Please enter your instance domain";
			return;
		}

		this.loading = true;
		this.error = null;

		try {
			// Normalize and validate the domain
			const domain = normalizeInstanceDomain(this.instanceDomain);

			// Register the OAuth app with the instance
			await auth.registerApp(domain, AUTH_CONFIG);

			// Redirect to the OAuth authorization page
			auth.startAuthFlow(AUTH_CONFIG);
		} catch (err) {
			this.loading = false;
			if (err instanceof ApiError) {
				this.error = `Failed to connect to instance: ${err.message}`;
			} else {
				this.error = "Failed to connect to instance. Please check the domain and try again.";
			}
			console.error("Login error:", err);
		}
	};

	return (
		<div class="page auth-page">
			<div class="auth-container">
				<h1>Log in</h1>
				<p>Enter your instance domain to continue. Your instance must either run Mastodon, a Mastodon fork (such as glitch-soc or Chuckya), or a MastoAPI-compatible server.</p>
                <br />
				<form on:submit={handleSubmit}>
					<div class="input-group">
						<label for="instance">Instance Domain</label>
						<input
							type="text"
							id="instance"
							placeholder="mastodon.social"
							value={use(this.instanceDomain)}
							disabled={use(this.loading)}
							autocomplete="url"
                            style="margin-left: .5em;"
						/>
					</div>

					{use(this.error).andThen(
						(err: string | null) => err && <div class="error-message">{err}</div>
					)}

					<button type="submit" class="primary" disabled={use(this.loading)}>
                        <span class="material-symbols-sharp">login</span>
                        {use(this.loading).map(loading => loading ? "Connecting..." : "Continue")}
					</button>
				</form>
                <br />
				<button class="secondary" on:click={() => router.navigate("/")}>
                    <span class="material-symbols-sharp">close</span>
					Cancel
				</button>
			</div>
		</div>
	);
};

export default Login;
